
export const marcoOpSsh_item = [
  {
    marcoOpSsh_item_instrumento: "DECRETO DE CREACIÓN SSH",
    marcoOpSsh_item_years: [
      {
        marcoOpSsh_item_year: "2026",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2025",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2024",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2023",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2022",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2021",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 6 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2020",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>
        /*"Contenido para el año 5 del Instrumento 1",*/
      },   
      {
        marcoOpSsh_item_year: "2019",
        marcoOpSsh_item_contenido: [
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2016/decreto de creacion ssh nov 2015.pdf">DECRETO SSH 2015 (16 NOV 2015)</a>,
        <br></br>,
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2021/DECRETO CREAC SSH 15 ABR 2019.pdf">DECRETO SSH 2019 (15 ABR 2019)</a>,
      ]
        /*"Contenido para el año 4 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2018",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2016/decreto de creacion ssh nov 2015.pdf">DECRETO SSH 2015 (16 NOV 2015)</a>
        /*"Contenido para el año 3 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2017",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2016/decreto de creacion ssh nov 2015.pdf">DECRETO SSH 2015 (16 NOV 2015)</a>
           /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2016",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/DECRETO DE CREACION/2016/decreto de creacion ssh nov 2015.pdf">DECRETO SSH 2015 (16 NOV 2015)</a>
        /*"Contenido para el año 1 del Instrumento 1",*/
      },
      // Agrega más años si es necesario
    ],
  },

  {
    marcoOpSsh_item_instrumento: "ESTATUTO ORGÁNICO SSH",
    marcoOpSsh_item_years: [
      {
        marcoOpSsh_item_year: "2026",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO ORGANICO SSH 2020 Y MODIFICACIONES.pdf">ESTATUTO ORGÁNICO SSH 2020 Y SUS MODIFICACIONES</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2026/Fe de erratas Estatuto Organico SSH 12032026.pdf">FE DE ERRATAS ESTATUTO SSH 2026 (12 MAR 2026)</a>,
        ]
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2025",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO ORGANICO SSH 2020 Y MODIFICACIONES.pdf">ESTATUTO ORGÁNICO SSH 2020 Y SUS MODIFICACIONES</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2024",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO ORGANICO SSH 2020 Y MODIFICACIONES.pdf">ESTATUTO ORGÁNICO SSH 2020 Y SUS MODIFICACIONES</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2023",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO ORGANICO SSH 2020 Y MODIFICACIONES.pdf">ESTATUTO ORGÁNICO SSH 2020 Y SUS MODIFICACIONES</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2022",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO ORGANICO SSH 2020 Y MODIFICACIONES.pdf">ESTATUTO ORGÁNICO SSH 2020 Y SUS MODIFICACIONES</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2021",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO ORGANICO SSH 2020 Y MODIFICACIONES.pdf">ESTATUTO ORGÁNICO SSH 2020 Y SUS MODIFICACIONES</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2020",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Estatuto organico 2016 Periodico Oficial 08082016.pdf">ESTATUTO SSH 2016 (8 AGO 2016)   </a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Fe de erratas Estatuto Organico de los SSH 15082016.pdf">FE DE ERRATAS ESTATUTO SSH 2016 (22 AGO 2016)</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/ESTATUTO  EL 3 AGO DE 2020.pdf">ESTATUTO SSH 2020 (3 AGO 2020)</a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2020/Modificaciones Estatuto P.O.E.  Nov. 2020.pdf">MODIF ESTATUTO SSH 2020 (23 NOV 2020)</a>
        ]
        /*"Contenido para el año 5 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2019",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Estatuto organico 2016 Periodico Oficial 08082016.pdf">ESTATUTO SSH 2016 (8 AGO 2016)   </a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Fe de erratas Estatuto Organico de los SSH 15082016.pdf">FE DE ERRATAS ESTATUTO SSH 2016 (22 AGO 2016)</a>,
        ]
        /*"Contenido para el año 4 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2018",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Estatuto organico 2016 Periodico Oficial 08082016.pdf">ESTATUTO SSH 2016 (8 AGO 2016)   </a>,
          <br></br>,
          <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Fe de erratas Estatuto Organico de los SSH 15082016.pdf">FE DE ERRATAS ESTATUTO SSH 2016 (22 AGO 2016)</a>,
        ]
        /*"Contenido para el año 3 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2017",
        marcoOpSsh_item_contenido: [
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Estatuto organico 2016 Periodico Oficial 08082016.pdf">ESTATUTO SSH 2016 (8 AGO 2016)  </a>,
        <br></br>,
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Fe de erratas Estatuto Organico de los SSH 15082016.pdf">FE DE ERRATAS ESTATUTO SSH 2016 (22 AGO 2016)</a>,
        ] /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2016",
        marcoOpSsh_item_contenido: [
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/ESTATUTO SERVICIOS DE SALUD 18 de noviembre 2014.pdf">ESTATUTO SSH 2014 (29 DIC 2014)  </a>,
        <br></br>,
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Estatuto organico 2016 Periodico Oficial 08082016.pdf">ESTATUTO SSH 2016 (8 AGO 2016)  </a>,
        <br></br>,
        <a target="_blank" href="/contenido/informacion/instrumentonormativoSSH/ESTATUTO ORGANICO/2016/Fe de erratas Estatuto Organico de los SSH 15082016.pdf">FE DE ERRATAS ESTATUTO SSH 2016 (22 AGO 2016)</a>,
      ]
        /*"Contenido para el año 1 del Instrumento 1",*/
      },
      // Agrega más años si es necesario
    ],
  },
  
  {
    marcoOpSsh_item_instrumento: "ESTRUCTURA ORGÁNICA SSH",
    marcoOpSsh_item_years: [
      {
        marcoOpSsh_item_year: "2026",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2024/ESTRUCTURA ORGANICA SSH 2024.pdf">ESTRUCTURA ORGÁNICA SSH 2024 (25 MAR 2024)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2025",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2024/ESTRUCTURA ORGANICA SSH 2024.pdf">ESTRUCTURA ORGÁNICA SSH 2024 (25 MAR 2024)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2024",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2024/ESTRUCTURA ORGANICA SSH 2024.pdf">ESTRUCTURA ORGÁNICA SSH 2024 (25 MAR 2024)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2023",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2021/ESTRUCTURA ORGANICA SSH 2021 (11 JUN 2021).pdf">ESTRUCTURA ORGÁNICA SSH 2021 (11 JUN 2021)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2022",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2021/ESTRUCTURA ORGANICA SSH 2021 (11 JUN 2021).pdf">ESTRUCTURA ORGÁNICA SSH 2021 (11 JUN 2021)</a>
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2021",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2020/VALID ESTRUCT SSH 2019  MAY.pdf">ESTRUCTURA ORGÁNICA SSH 2019 (14 MAY 2019)</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2021/ESTRUCTURA ORGANICA SSH 2021 (11 JUN 2021).pdf">ESTRUCTURA ORGÁNICA SSH 2021 (11 JUN 2021)</a>
        ]
        /*"Contenido para el año 6 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2020",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2020/VALID ESTRUCT SSH 2019  MAY.pdf">ESTRUCTURA ORGÁNICA SSH 2019 (14 MAY 2019)</a>,
        /*"Contenido para el año 5 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2019",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2016/VALID ESTRUCT SSH SEP 2016.pdf">ESTRUCTURA ORGÁNICA SSH 2016 (21 JUL 2016)</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2020/VALID ESTRUCT SSH 2019  MAY.pdf">ESTRUCTURA ORGÁNICA SSH 2019 (14 MAY 2019)</a>,
        ]
        /*"Contenido para el año 4 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2018",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2016/VALID ESTRUCT SSH SEP 2016.pdf">ESTRUCTURA ORGÁNICA SSH 2016 (21 JUL 2016)</a>,
        /*"Contenido para el año 3 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2017",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2016/VALID ESTRUCT SSH SEP 2016.pdf">ESTRUCTURA ORGÁNICA SSH 2016 (21 JUL 2016)</a>,
        /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2016",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2016/ESTRUCTURA APROBA SISCMRDESERVICIOS DE SALUD DE HIDALGO.pdf">ESTRUCTURA ORGÁNICA SSH 2014</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/ESTRUCTURA ORGANICA/2016/VALID ESTRUCT SSH SEP 2016.pdf">ESTRUCTURA ORGÁNICA SSH 2016 (21 JUL 2016)</a>,
        ]
        /*"Contenido para el año 1 del Instrumento 1",*/
      },
      // Agrega más años si es necesario
    ],
  },

  {
    marcoOpSsh_item_instrumento: "MANUAL DE ORGANIZACIÓN SSH",
    marcoOpSsh_item_years: [
      {
        marcoOpSsh_item_year: "2026",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2025/Manual de Organizacion 2025.pdf">MANUAL ORGANIZACIÓN SSH  2025 (ABR 2025)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2025",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2025/Manual de Organizacion 2025.pdf">MANUAL ORGANIZACIÓN SSH  2025 (ABR 2025)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2024",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2021/Manual de Organizacion 2021.pdf">MANUAL ORGANIZACIÓN SSH  2021 (8 MAY 2021)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2023",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2021/Manual de Organizacion 2021.pdf">MANUAL ORGANIZACIÓN SSH  2021 (8 MAY 2021)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2022",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2021/Manual de Organizacion 2021.pdf">MANUAL ORGANIZACIÓN SSH  2021 (8 MAY 2021)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2021",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2020/MANUAL ORGANIZACION  2020.pdf">MANUAL ORGANIZACIÓN 2020 (AGO 2020)</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2021/Manual de Organizacion 2021.pdf">MANUAL ORGANIZACIÓN SSH  2021 (8 MAY 2021)</a>,
        ]
        /*"Contenido para el año 6 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2020",
        marcoOpSsh_item_contenido: [
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2016/M.O Serv. Salud 03 OCT 16.pdf">MANUAL ORGANIZACIÓN 2016 (3 OCT 2016)</a>,
        <br></br>,
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2020/MANUAL ORGANIZACION  2020.pdf">MANUAL ORGANIZACIÓN 2020 (AGO 2020)</a>,
      ]
        /*"Contenido para el año 5 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2019",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2016/M.O Serv. Salud 03 OCT 16.pdf">MANUAL ORGANIZACIÓN 2016 (3 OCT 2016)</a>,
        /*"Contenido para el año 4 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2018",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2016/M.O Serv. Salud 03 OCT 16.pdf">MANUAL ORGANIZACIÓN 2016 (3 OCT 2016)</a>,
        /*"Contenido para el año 3 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2017",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2016/M.O Serv. Salud 03 OCT 16.pdf">MANUAL ORGANIZACIÓN 2016 (3 OCT 2016)</a>,
         /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2016",
        marcoOpSsh_item_contenido:[ 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2016/Manual de Org. Ssh 2006.pdf">MANUAL ORGANIZACIÓN SSH 2006</a>,
        <br></br>,
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL ORGANIZACION/2016/M.O Serv. Salud 03 OCT 16.pdf">MANUAL ORGANIZACIÓN 2016 (3 OCT 2016)</a>,
        ]
        /*"Contenido para el año 1 del Instrumento 1",*/
      },
      // Agrega más años si es necesario
    ],
  },

  {
    marcoOpSsh_item_instrumento: "MANUAL DE PROCEDIMIENTOS SSH",
    marcoOpSsh_item_years: [
      {
        marcoOpSsh_item_year: "2026",
        marcoOpSsh_item_contenido: 
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2025/Manual de Procedimientos 2025.pdf">MANUAL PROCEDIMIENTOS SSH 2025 (JULIO 2025)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2025",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2021/Manual de Procedimientos 2021.pdf">MANUAL PROCEDIMIENTOS SSH 2021 (8 MAY 2021)</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2025/Manual de Procedimientos 2025.pdf">MANUAL PROCEDIMIENTOS SSH 2025 (JULIO 2025)</a>,
        ]
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2024",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2021/Manual de Procedimientos 2021.pdf">MANUAL PROCEDIMIENTOS SSH 2021 (8 MAY 2021)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2023",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2021/Manual de Procedimientos 2021.pdf">MANUAL PROCEDIMIENTOS SSH 2021 (8 MAY 2021)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2022",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2021/Manual de Procedimientos 2021.pdf">MANUAL PROCEDIMIENTOS SSH 2021 (8 MAY 2021)</a>,
        /*"Contenido para el año 7 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2021",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2020/MANUAL DE PROCEDIMIENTOS SSH JUN 2020 c (1).pdf">MANUAL PROCEDIMIENTOS SSH 2020 (13 JUL 2020)</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2021/Manual de Procedimientos 2021.pdf">MANUAL PROCEDIMIENTOS SSH 2021 (8 MAY 2021)</a>,
        ]
        /*"Contenido para el año 6 del Instrumento 1",*/
      },           
      {
        marcoOpSsh_item_year: "2020",
        marcoOpSsh_item_contenido: [
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2016/Man. Proc Gral SSH 2004 o.k..pdf">MANUAL PROCEDIMIENTOS SSH 2004</a>,
          <br></br>,
          <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2020/MANUAL DE PROCEDIMIENTOS SSH JUN 2020 c (1).pdf">MANUAL PROCEDIMIENTOS SSH 2020 (13 JUL 2020)</a>,
        ]
        /*"Contenido para el año 5 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2019",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2016/Man. Proc Gral SSH 2004 o.k..pdf">MANUAL PROCEDIMIENTOS SSH 2004</a>,
        /*"Contenido para el año 4 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2018",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2016/Man. Proc Gral SSH 2004 o.k..pdf">MANUAL PROCEDIMIENTOS SSH 2004</a>,
        /*"Contenido para el año 3 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2017",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2016/Man. Proc Gral SSH 2004 o.k..pdf">MANUAL PROCEDIMIENTOS SSH 2004</a>,
        /*"Contenido para el año 2 del Instrumento 1",*/
      },
      {
        marcoOpSsh_item_year: "2016",
        marcoOpSsh_item_contenido: 
        <a target="_blank" href="../contenido/informacion/instrumentonormativoSSH/MANUAL DE PROCEDIMIENTOS/2016/Man. Proc Gral SSH 2004 o.k..pdf">MANUAL PROCEDIMIENTOS SSH 2004</a>,
        /*"Contenido para el año 1 del Instrumento 1",*/
      },
      // Agrega más años si es necesario
    ],
  },


  // Agrega más instrumentos si es necesario
];
